<template>
  <div v-if="data" class="header-section">
    <b-row>
      <b-col>
        <h1>Quote: {{ data.QuoteNumber }}</h1>
      </b-col>
      <b-col>
        <b-button
          type="button"
          class="btn-print pull-right"
          variant="warning"
          @click="convertToOrder"
        >
          {{ getContentItem("convertToOrder") }}
        </b-button>
      </b-col>
    </b-row>
    <b-row class="my-3 mx-0">
      <b-col class="detail-bubble">
        <h3>{{ getContentItem("billTo") }}</h3>
        <p class="detail-address">
          {{ billToName }}
        </p>
      </b-col>
      <b-col sm="2" />
      <b-col class="detail-bubble">
        <h3>{{ getContentItem("shipTo") }}</h3>
        <p class="detail-address">
          {{ shipToName }}
        </p>
      </b-col>
    </b-row>
    <b-row class="my-3 mx-0">
      <b-col class="detail-bubble">
        <h3 class="mb-3">
          {{ getContentItem("details") }}
        </h3>
        <b-row>
          <b-col xs="12" sm="4">
            <static-form-control
              id="quote-number"
              :label-text="getContentItem('quoteNumber')"
              :value="data.QuoteNumber"
              :cols="6"
            />
          </b-col>
          <b-col xs="12" sm="4">
            <static-form-control
              id="quoted-by"
              :label-text="getContentItem('quotedBy')"
              :value="data.QuotedBy"
              :cols="6"
            />
          </b-col>
          <b-col xs="12" sm="4">
            <static-form-control
              id="quoted-to"
              :label-text="getContentItem('quotedTo')"
              :value="data.QuotedTo"
              :cols="6"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col xs="12" sm="4">
            <static-form-control
              id="dealer-code"
              :label-text="getContentItem('dealerCode')"
              :value="data.DealerCode"
              :cols="6"
            />
          </b-col>
          <b-col xs="12" sm="4">
            <static-form-control
              id="date-quoted"
              :label-text="getContentItem('date')"
              :value="formatDate(data.DateQuoted)"
              :cols="6"
            />
          </b-col>
          <b-col xs="12" sm="4">
            <static-form-control
              id="expire-date"
              :label-text="getContentItem('expireDate')"
              :value="formatDate(data.ExpireDate)"
              :cols="6"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import moment from "moment";

  import { mapGetters } from "vuex";

  import { StaticFormControl } from "@/components/Elements";

  export default {
    name: "QuoteHeader",
    components: {
      StaticFormControl
    },
    computed: {
      ...mapGetters(["getContentItem"]),
      billToName() {
        return this.data && this.data.BillTo ? this.data.BillTo.Name : null;
      },
      shipToName() {
        return this.data && this.data.BillTo ? this.data.BillTo.Name : null;
      }
    },
    props: {
      data: {
        type: Object,
        required: true
      }
    },
    methods: {
      formatDate: function(value) {
        return moment(value).format("MM/DD/YYYY");
      },

      convertToOrder: function(e) {
        e.preventDefault();
        this.data.showForm();
      }
    }
  };
</script>
